import React from 'react'
import "../CSS/Skill.css"
import SkillData from "./SkillData"
import Cards from "./Cards";

const Skill = () => {
    return (
    <>
        
        <div className="backSkill">
            <div className="headerSkill">
                <h1> My Skills</h1>
            </div>
            <div className="containerSkill">    
                {
                    SkillData.map((val,index) => {
                        return <Cards 
                        imgsrc={val.imgsrc}
                        title={val.title}
                        per={val.per}
                        />
                    })
                }
            </div>
        </div>
        
      
    
    </>
    )
}

export default Skill

